/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import { ErrorResponse, HintResponseCollectionResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Hints<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Hints
   * @name HintsList
   * @request GET:/Hints
   * @response `200` `HintResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  hintsList = (params: RequestParams = {}) =>
    this.http.request<HintResponseCollectionResponse, ErrorResponse>({
      path: `/Hints`,
      method: 'GET',
      format: 'json',
      ...params,
    });
}
